import { render, staticRenderFns } from "./TabsCustomGraphic.vue?vue&type=template&id=35aa1432&scoped=true&"
import script from "./TabsCustomGraphic.vue?vue&type=script&lang=js&"
export * from "./TabsCustomGraphic.vue?vue&type=script&lang=js&"
import style0 from "./TabsCustomGraphic.vue?vue&type=style&index=0&id=35aa1432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa1432",
  null
  
)

export default component.exports